<template>
  <RouterLink v-if="to.name" :to="route">
    <slot/>
  </RouterLink>
</template>

<script lang="ts">
export default {
  name: 'LangRouterLink',
  props: {
    to: {
      type: Object,
      required: true
    }
  },
  computed: {
    route() {
      return {...this.to, name: this.to.name.includes(':') ? this.to.name : `${this.to.name}:${this.$i18n.locale}`}
    }
  }
}
</script>